module.exports = __webpack_public_path__ + "static/media/5DPO6.f9161a73.jpg";